import { render, staticRenderFns } from "./currentsAccounts.vue?vue&type=template&id=435fe5dc&scoped=true&"
import script from "./currentsAccounts.vue?vue&type=script&lang=js&"
export * from "./currentsAccounts.vue?vue&type=script&lang=js&"
import style0 from "./currentsAccounts.vue?vue&type=style&index=0&id=435fe5dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435fe5dc",
  null
  
)

export default component.exports